<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row justify="center">
          <CassInfographic
            v-for="info in infographicLists"
            :key="info.title"
            :title="info.title"
            :action="info.action"
            :action-text="info.actionText"
            :lists="info.lists"
            :data="info.data"
            class="ma-2"
          ></CassInfographic>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CassInfographic from '../components/cards/CassInfographic'

export default {
  name: 'HomePage',
  components: { CassInfographic },
  computed: {
    infographicLists() {
      return [
        {
          title: this.$t('title_txt_bus_info'),
          action: { name: 'Employee' },
          actionText: this.$t('btn_txt_emp_set'),
          lists: [
            this.$t('cap_txt_bus_name', {
              value: this.$store.state.tenant.name
            }),
            this.$t('cap_txt_bus_id', {
              value: this.$store.state.tenant.documentId
            }),
            this.$t('cap_txt_bus_size', {
              value: this.$t('cap_emp_count', {
                value: this.$store.getters['employee/countEmployees']
              })
            }),
            this.$t('cap_txt_bus_branch', {
              value: this.$store.getters['tenant/activeBranches'].length
            })
          ]
        },
        {
          title: this.$t('title_txt_bill_payment_card'),
          action: { name: 'Payment' },
          actionText: this.$t('btn_txt_bill_payment_set'),
          lists: [
            this.$t('cap_txt_this_month_pay', {
              amount: this.$store.getters['bill/estimateBill'].charge,
              plan: this.$store.getters['bill/estimateBill'].plan
            }),
            this.$t('cap_txt_due', {
              amount: `${this.$store.getters['bill/dueAmount']} USD`
            }),
            this.$t('cap_txt_bank_card', { number: 'N/A' })
          ]
        },
        {
          title: this.$t('title_txt_order_info'),
          action: { name: 'Order' },
          actionText: this.$t('btn_txt_order_set'),
          lists: [
            this.$t('cap_txt_order_today', {
              value: this.$store.getters['order/todayOrder'].length
            }),
            this.$t('cap_txt_order_new', {
              value: this.$store.getters['order/newOrder'].length
            }),
            this.$t('cap_txt_order_user', {
              value: this.$store.state.tenant.totalUsers
            })
          ]
        },
        {
          title: this.$t('title_txt_up_info'),
          action: '',
          actionText: this.$t('btn_txt_up_req'),
          lists: [
            // this.$t('cap_txt_up_date', { value: 'August 30th, 2020' }),
            this.$t('cap_txt_up_1'),
            this.$t('cap_txt_up_2'),
            this.$t('cap_txt_up_3')
          ]
        }
      ]
    }
  }
}
</script>
